/* eslint-disable no-redeclare,curly */
function isIOS9 () {
    return !!window.navigator.userAgent.match(/(iPhone|iPad|iPod).* OS (9|\d{2})_\d/)
}

let utils = {

    showToast: function (msg, duration, callback) {
        msg = msg || ''
        duration = duration || 2
        var toast = document.createElement('div')
        toast.innerHTML = '<div class="toast-container"><div class="x-toast">' +
            '<span class="msg"></span></div></div>'
        toast.getElementsByClassName('msg')[0].innerHTML = msg
        document.body.appendChild(toast)
        setTimeout(function () {
            document.body.removeChild(toast)
            callback && callback()
        }, duration * 1000)
    },

    showConfirm: function (text, title, confirmText, cancelText, callback) {
        var dialog = document.createElement('div')
        dialog.innerHTML = '<div class="xdialog"><div class="xbody">' +
            '<div class="content"></div>' +
            '<div class="btns"><button class="btn cancel-btn"></button>' +
            '<button class="btn confirm-btn"></button>' +
            '</div></div></div>'
        var contentEl = dialog.getElementsByClassName('content')[0]
        var cancelBtn = dialog.getElementsByClassName('cancel-btn')[0]
        var confirmBtn = dialog.getElementsByClassName('confirm-btn')[0]
        var dialog = dialog.getElementsByClassName('xdialog')[0]

        contentEl.innerHTML = text
        cancelBtn.innerHTML = cancelText || '取消'
        confirmBtn.innerHTML = confirmText || '确定'

        confirmBtn.onclick = function () {
            document.body.removeChild(dialog)
            callback && callback(1)
        }
        cancelBtn.onclick = function () {
            document.body.removeChild(dialog)
            callback && callback(0)
        }

        dialog.onclick = function () {
            document.body.removeChild(dialog)
        }

        document.body.appendChild(dialog)
    }

}

let env = {

    isMobile: function () {
        if (env.isAndroid() || env.isIos())
            return true
        var userAgent = window.navigator.userAgent
        var isWindowsPhone = !!userAgent.match(/Windows Phone/i) || !!userAgent.match(/IEMobile/i)
        return !!isWindowsPhone
    },

    isIos: function () {
        return !!navigator.userAgent.match(/(iPhone|iPad|iPod)/i)
    },

    isIOS9: isIOS9,

    isAndroid: function () {
        return !!navigator.userAgent.match(/Android/i)
    },

    /**
     * 在浏览器中唤起app
     * @param url
     * @param callback   function(isTimeout)
     * @param [autoLoadForIos9]
     * @param [iosAlertOptions]  {Object} ios9提醒选项
     * @param [iosAlertOptions.msg]  非app环境下的提示消息
     * @param [iosAlertOptions.title]   标题
     */
    openApp: function (schemeUrl, callback, iosAlertOptions) {

        var body, clear, hide, node, now, timer
        if (!schemeUrl) {
            return
        }
        //ios9 不支持iframe + scheme唤起
        // if (isIOS9()) {
        //     // 显示提示框
        //     iosAlertOptions = iosAlertOptions || {}

        //     var alertMsg = iosAlertOptions.msg || '亲，下一步功能需要下载安装广发证券易淘金App。若您已下载，可直接打开App进行操作。'
        //     var alertTitle = iosAlertOptions.title || '温馨提示'
        //     var alertIcon = iosAlertOptions.title ? 'warning' : 'info'
        //     var title = '<span class="icon icon-' + alertIcon + '"></span><span>' + alertTitle + '</span>'

        //     utils.showConfirm(alertMsg, title, '立即打开', '立即下载', function (confirmed) {
        //         if (confirmed){
        //             window.location.href = schemeUrl
        //         } else {
        //             window.location.href = iosAlertOptions.downloadUrl
        //         }
        //     })
        //     return
        // }
        node = document.createElement('iframe')
        node.style.display = 'none'
        body = document.body
        clear = function (isTimeout) {
            (typeof callback === 'function') && callback(isTimeout)
            window.removeEventListener('pagehide', hide, true)
            window.removeEventListener('pageshow', hide, true)
            if (!node) {
                return
            }
            node.onload = null
            body.removeChild(node)
            node = null
        }
        hide = function (e) {
            console.log('hide')
            clearTimeout(timer)
            clear(false)
        }
        window.addEventListener('pagehide', hide, true)
        window.addEventListener('pageshow', hide, true)
        node.onload = clear
        node.src = schemeUrl
        body.appendChild(node)
        now = +new Date()
        timer = setTimeout(function () {
            timer = setTimeout(function () {
                var newTime = new Date()
                if (newTime - now > 1280) {
                    return clear(false)
                } else {
                    return clear(true)
                }
            }, 1200)
        }, 60)
    }

}

let getDownloadUrl = function (response) {
    if (response.status === 200 && response.data && response.data.data) {
        return response.data.data.downloadUrl
    } else {
        return null
    }
}

let getVersion = function (response) {
	if (response.status === 200 && response.data && response.data.data) {
		return response.data.data.appVersion
	} else {
		return null
	}
}

let compareVersion = function (stringA, stringB) {
	let arrayA = stringA.split('.')
	let arrayB = stringB.split('.')

	if (arrayA.length === 3) {
		arrayA.push(-1);
	}

	if (arrayB.length === 3) {
		arrayB.push(-1);
	}

	for (let i = 0; i< arrayA.length; i++) {
		if (parseInt(arrayA[i]) > parseInt(arrayB[i])) {
			return 1;
		}

		if (parseInt(arrayA[i]) < parseInt(arrayB[i])) {
			return -1;
		}
	}

	return 0
}

export { utils, env, getDownloadUrl, getVersion, compareVersion}




// WEBPACK FOOTER //
// ./src/common/js/app-download-util.js